import { useState } from "react";
import { Maximize2, X } from "lucide-react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Reveal } from "./Reveal";

const TIMELINE_IMG = "https://customer-assets.emergentagent.com/job_sabbath-way/artifacts/kir74ein_ChatGPT%20Image%20Jul%201%2C%202026%2C%2010_22_01%20PM.png";

export const Timeline = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="timeline" data-testid="timeline-section" className="bg-[#141311] py-24 md:py-32 border-y border-[#2B2825]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-4">
            How We Got Here
          </p>
          <h2 className="font-heading font-light tracking-tight text-4xl md:text-6xl max-w-4xl leading-tight mb-6">
            The timeline of <span className="italic text-[#D4AF37]">man-made</span> denominations.
          </h2>
          <p className="text-base md:text-lg leading-relaxed font-light text-[#A39E98] max-w-2xl mb-12">
            From the Apostles to modern institutions — see how the truth was
            divided over the centuries. The more man separates from the Word,
            the more denominations multiply. Tap the image to explore it full-size.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <button
            data-testid="timeline-image-trigger"
            onClick={() => setOpen(true)}
            className="group relative block w-full overflow-hidden border border-[#2B2825]"
          >
            <img
              src={TIMELINE_IMG}
              alt="Timeline of Major Christian Denominations and Their Founders"
              className="w-full h-auto transition-transform duration-700 group-hover:scale-[1.02]"
            />
            <div className="absolute inset-0 bg-[#0A0A0A]/0 group-hover:bg-[#0A0A0A]/20 transition-colors" />
            <span className="absolute bottom-4 right-4 flex items-center gap-2 border border-[#D4AF37] bg-[#0A0A0A]/70 backdrop-blur-sm text-[#D4AF37] px-4 py-2 text-xs tracking-wide uppercase font-mono opacity-90 group-hover:opacity-100 transition-opacity">
              <Maximize2 strokeWidth={1.5} className="h-4 w-4" />
              Expand
            </span>
          </button>
        </Reveal>
      </div>

      <DialogPrimitive.Root open={open} onOpenChange={setOpen}>
        <DialogPrimitive.Portal>
          <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/95 backdrop-blur-sm data-[state=open]:animate-in data-[state=open]:fade-in-0" />
          <DialogPrimitive.Content
            data-testid="timeline-image-modal"
            className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-10 focus:outline-none data-[state=open]:animate-in data-[state=open]:fade-in-0"
          >
            <DialogPrimitive.Title className="sr-only">Timeline of Major Christian Denominations</DialogPrimitive.Title>
            <DialogPrimitive.Description className="sr-only">
              Full-size timeline image of major Christian denominations and their founders.
            </DialogPrimitive.Description>
            <DialogPrimitive.Close
              data-testid="timeline-image-close"
              className="fixed top-6 right-6 z-10 flex items-center gap-2 text-[#A39E98] hover:text-[#F4F0EA] transition-colors"
            >
              <span className="text-sm tracking-wide">Close</span>
              <X strokeWidth={1} className="h-5 w-5" />
            </DialogPrimitive.Close>
            <img
              src={TIMELINE_IMG}
              alt="Timeline of Major Christian Denominations and Their Founders"
              className="max-h-full max-w-full object-contain border border-[#4A453F]"
            />
          </DialogPrimitive.Content>
        </DialogPrimitive.Portal>
      </DialogPrimitive.Root>
    </section>
  );
};
